export default "__VITE_ASSET__BtPXNI_C__"